import { useDocumentTitle } from '@/hooks/useDocumentTitle';
import { Globe, Target, Clock } from 'lucide-react';

const metrics = [
  {
    value: '7+',
    label: 'Years of Combined Leadership Experience',
    icon: Globe,
  },
  {
    value: '5',
    label: 'Countries of Planned Expansion',
    icon: Globe,
  },
  {
    value: '',
    label: 'Precision-First Delivery Approach',
    icon: Target,
  },
  {
    value: '24/7',
    label: 'Technical Support Availability',
    icon: Clock,
  },
];

export default function ProjectExperience() {
  useDocumentTitle('Project Experience — Straton Group');

  return (
    <main id="main-content">
      {/* ── Hero Section ── */}
      <section className="relative min-h-[60vh] lg:min-h-[70vh] flex items-end">
        {/* Background image */}
        <div className="absolute inset-0">
          <img
            src="/project-hero.webp" fetchPriority="high"
            alt="Advanced manufacturing facility"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-bg-primary via-bg-primary/80 to-bg-primary/30" />
        </div>

        {/* Text content */}
        <div className="relative z-10 w-full max-w-[1400px] mx-auto section-padding pb-16 lg:pb-24">
          {/* Label with line */}
          <div className="flex items-center gap-4 mb-6">
            <div className="w-8 h-px bg-text-muted" />
            <span className="text-xs uppercase tracking-[0.2em] text-text-muted">
              Track Record
            </span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold uppercase tracking-[0.15em] text-text-primary mb-6 leading-tight">
            Environments<br />
            We Operate In
          </h1>

          <div className="w-8 h-px bg-text-muted mb-6" />

          <p className="body-text max-w-lg">
            Across advanced manufacturing facilities and high-performance production environments worldwide.
          </p>
        </div>
      </section>

      {/* ── Stats Section ── */}
      <section className="bg-bg-primary section-padding py-16 lg:py-24">
        <div className="max-w-[1400px] mx-auto">
          <div className="border border-border-secondary">
            <div className="grid grid-cols-2 lg:grid-cols-4">
              {metrics.map((metric, i) => (
                <div
                  key={metric.label}
                  className={`flex flex-col items-center text-center py-12 lg:py-16 px-6 ${
                    i < metrics.length - 1 ? 'border-r border-border-secondary' : ''
                  } ${i === 1 ? 'border-r-0 lg:border-r' : ''}`}
                >
                  {/* Icon */}
                  <metric.icon
                    className="w-6 h-6 text-text-muted mb-6"
                    strokeWidth={1.2}
                  />

                  {/* Value */}
                  <span className="text-3xl md:text-4xl lg:text-5xl font-light text-text-primary tracking-wider mb-4 flex items-center justify-center min-h-[1em]">
                    {metric.value ? (
                      metric.value
                    ) : (
                      <metric.icon className="w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12" strokeWidth={1.2} />
                    )}
                  </span>

                  {/* Divider */}
                  <div className="w-6 h-px bg-text-muted mb-4" />

                  {/* Label */}
                  <span className="text-[10px] uppercase tracking-[0.15em] text-text-muted leading-relaxed max-w-[140px]">
                    {metric.label}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── Testimonial Section ── */}
      {/* Testimonial hidden pending real client feedback */}
    </main>
  );
}
